export default "__VITE_ASSET__iC8miHDp__"